import { Flex } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function AdminBlocklistLayout() {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        minHeight: '100dvh',
      }}
    >
      <Outlet />
    </Flex>
  );
}
